import { Component, OnInit, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { EleitorCsvDTO } from 'src/app/models/eleitorCsvDTO.model';
import { EleitorDTO } from 'src/app/models/eleitorDTO.model';
import { NewEleitorDTO } from 'src/app/models/newEleitorDTO.model';
import { NgxSpinnerService } from 'ngx-spinner';
import { Utils } from 'src/app/utils/utils';
import { EnvioComponent } from 'src/app/pages/gestor/parametrizacoes-email/envio/envio.component';

@Component({
  selector: 'app-massa-email',
  templateUrl: './email-csv-import.component.html',
  styleUrls: ['./email-csv-import.component.css']
})
export class EmailCsvComponent implements OnInit {
  @ViewChild('closebutton', {static: true}) closebutton;
  public eleitoresCsv: EleitorCsvDTO[] = [];
  idEleicao: any;
  idGestor: number;
  token: any;
  eleitores: EleitorDTO[];
  editandoEleitor: boolean = false;
  idEleitorEditando: any;
  newEleitorDTO: NewEleitorDTO = new NewEleitorDTO();
  newEleitores: NewEleitorDTO[] = [];
  eleitoresValidacao: NewEleitorDTO[] = [];
  criticaValidacao: any = [];
  enviados: any = [];
  duplicados: any = [];
  eleicao: any;
  ativaNavValidacao: boolean = false;
  ativaNavEnviar: boolean = false;
  ativaNavEnviados: boolean = false;
  paginaAtual : Number = 1 ;
  contador : Number = 30;

  constructor(
    private envioComponent: EnvioComponent,
    protected messageService: MessageService,
    public spinner: NgxSpinnerService,
    public utils: Utils,
  ) { }

  async ngOnInit() {

    this.idEleicao = JSON.parse(sessionStorage.getItem("eleicaoClicadaParametrizacao")).id;
    this.eleicao = JSON.parse(sessionStorage.getItem("eleicaoClicadaParametrizacao"));
    this.idGestor = JSON.parse(sessionStorage.getItem("infoGestor")).id;
    this.token = sessionStorage.getItem("token");
  }

  validaNavTab() {
    if (this.criticaValidacao.length > 0 && this.duplicados.length == 0 && this.enviados.length == 0) {
      this.ativaNavValidacao = true;
    } else {
      this.ativaNavValidacao = false;
    }

    if (this.criticaValidacao.length == 0 && this.newEleitores.length > 0) {
      this.ativaNavEnviar = true;
    } else {
      this.ativaNavEnviar = false;
    }
  }

  validaNavTabAposSalvar() {
    this.ativaNavEnviar = false;
    this.ativaNavValidacao = false;
    this.fileReset();
    this.zerarInputFile(null);
    this.enviados = [];
    this.criticaValidacao = [];
    this.newEleitores = [];
  }

  okImportar(element) {
    if (this.enviados.length > 0) {
      this.enviados = [];
    }
    if (this.duplicados.length > 0) {
      this.duplicados = [];
    }
    if (this.eleitoresValidacao.length > 0) {
      this.eleitoresValidacao = [];
    }
    if (this.criticaValidacao.length > 0) {
      this.criticaValidacao = [];
    }
    if (this.newEleitores.length > 0) {
      this.criticaValidacao = [];
    }
    element.value = '';
  }

  zerarInputFile(element) {
    if (element) {
      element.value = '';
    }
    this.newEleitores = [];
    this.eleitoresValidacao = [];
    this.criticaValidacao = [];
  }

  importarList() {
    this.carregarListaEleitores(this.newEleitores, this.token);
    this.closebutton.nativeElement.click();
  }

  public carregarListaEleitores(eleitores: NewEleitorDTO[], token: any) {
    this.envioComponent.eleitoresPorImportacaoLista(eleitores)
    this.validaNavTabAposSalvar();
    if (eleitores.length > 0) {
      //this.eleitorComponent.buscarEleitoresPorEleicaoIdPage(10,0);
      this.messageService.add({ key: 'toast', severity: 'success', summary: 'Sucesso!', detail: 'Eleitores carregados com sucesso!' });
    }
  }

  // CSV
  importarCsv(event) {

    this.zerarInputFile(null);

    let arquivos = event.srcElement.files;

    if (this.validaTipoArquivo(arquivos[0])) {
      let input = event.target;
      let fileReader = new FileReader();
      fileReader.readAsText(input.files[0]);

      fileReader.onload = () => {
        let csvData = fileReader.result;
        let csvRecordsArray = csvData.toString().split(/\r\n|\n/);
        let headersRow = this.utils.getHeaderArray(csvRecordsArray);
        this.eleitoresCsv = this.getDataRecordsArrayFromCSVFile(csvRecordsArray, headersRow.length);
        this.eleitoresCsvToNewEleitores(this.eleitoresCsv);
        this.validaNavTab();
      };

      fileReader.onerror = () => {
        this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção', detail: 'Ocorreu um erro ao tentar ler o arquivo!' });
      };

    } else {
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção', detail: 'O arquivo selecionado não é um .csv válido!' });
      this.fileReset();
    }
  }

  validaTipoArquivo(file: any) {
    return file.name.endsWith(".csv");
  }

  getDataRecordsArrayFromCSVFile(csvRecordsArray: any, headerLength: any) {
    let csvArr = [];

    for (let i = 1; i < csvRecordsArray.length; i++) {
      let curruntRecord = csvRecordsArray[i].split(';');
      if (curruntRecord.length == headerLength) {
        let eleitorCsv: EleitorCsvDTO = new EleitorCsvDTO();
        eleitorCsv.login = curruntRecord[0].trim();
        eleitorCsv.email = curruntRecord[1].trim();
        csvArr.push(eleitorCsv);
      }
    }
    return csvArr;
  }

  fileReset() {
    this.eleitoresCsv = [];
  }

  registrarCriticasImportacao(eleitor: NewEleitorDTO, critica: any) {
    this.eleitoresValidacao.push(eleitor);
    const eleitorCriticado = eleitor;
    this.criticaValidacao.push({ eleitorCriticado, critica: critica });
    return this.criticaValidacao

  }

  eleitoresCsvToNewEleitores(eleitoresCsv: EleitorCsvDTO[]) {
    const expressaoRegular = /[^A-Za-z0-9\@\.\_\-]/g;
    const expressaoRegularEmail = /\S+@\S+\.\S+/;

    for (let eleitor of eleitoresCsv) {
      this.newEleitorDTO.login = eleitor.login;
      this.newEleitorDTO.email = eleitor.email;
      this.newEleitorDTO.eleicao = { "id": this.idEleicao };
      this.newEleitorDTO.idGestor = this.idGestor;

      if (this.newEleitorDTO.login == null || this.newEleitorDTO.login == '') {
        this.registrarCriticasImportacao(this.newEleitorDTO, "Validação 1");

      } else if (expressaoRegular.test(this.newEleitorDTO.login) == true) {
        this.registrarCriticasImportacao(this.newEleitorDTO, "Validação 2 ou 3");

      } else if (expressaoRegularEmail.test(this.newEleitorDTO.email) == false || this.newEleitorDTO.email == '') {
        this.registrarCriticasImportacao(this.newEleitorDTO, "Validação 4");

      } else {
        this.newEleitores.push(this.newEleitorDTO);
      }
      this.newEleitorDTO = new NewEleitorDTO();
    }

  }

}
